var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('van-button',{attrs:{"round":"","block":"","type":"info"},on:{"click":_vm.clearData}},[_vm._v("清空localStorage")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }